<template>
  <v-app v-resize="onResize">
    <template v-if="!$route.meta.public && token && !config.DEV_MODULE">
      <i4proSidebar v-if="configLayout.sidebar || innerWidth <= 991" :model="primaryDrawer" />

      <i4proHeader :innerWidth="innerWidth">
        <template v-if="configLayout.sidebar || innerWidth <= 991" v-slot:sidebar>
          <v-icon id="menu-icon" dark @click.stop="primaryDrawer = !primaryDrawer" class="mr-2">menu</v-icon>
        </template>
      </i4proHeader>

      <v-main id="mainContent" :style="background">
        <div>
          <i4proSidebarDinamic />

          <transition name="page">
            <router-view></router-view>
          </transition>
        </div>
      </v-main>

      <v-footer app v-if="configFooter.visible" v-bind="configFooter.atributes" :style="backgroundFooter">
        <i4pro-form v-if="showForm && configFooter.showPage" :page="configFooter.page" :context="configFooter.mode" />

        <span v-if="!configFooter.showPage" class="px-3">&copy; {{ new Date().getFullYear() }}</span>
      </v-footer>

      <i4proBackToTop />
    </template>

    <template v-else-if="!$route.meta.public && token && config.DEV_MODULE">
      <router-view :key="$route.fullpath"></router-view>
    </template>

    <template v-else>
      <v-main id="mainContent" class="reset-content">
        <transition name="page">
          <keep-alive>
            <router-view :key="$route.fullpath"></router-view>
          </keep-alive>
        </transition>
      </v-main>
    </template>

    <i4proSnackBar />
    <i4proDialogError500 v-bind="getError500" />
    <i4proLoader />
  </v-app>
</template>

<script>
import { getToken } from '@/services/authentication';
import store from '@/store';
import * as HANDLERS from '@/helpers/types/handlers';

export default {
  components: {
    i4proBackToTop: () => import('@/components/buttons/i4pro-back-to-top'),
    i4proHeader: () => import('@/components/headers/i4pro-header'),
    i4proSidebar: () => import('@/components/sidebar/i4pro-sidebar'),
    i4proSnackBar: () => import('@/components/snackbars/i4pro-snackbar'),
    i4proDialogError500: () => import('@/components/errors/i4pro-dialog-error-500'),
    i4proSidebarDinamic: () => import('@/components/sidebar/i4pro-sidebar-dinamic'),
    i4proForm: () => import('@/components/layouts/i4pro-form'),
    i4proLoader: () => import('@/components/loader/i4pro-loader')
  },

  data: () => ({
    token: '',
    primaryDrawer: false,
    innerWidth: 0,
    background: '',
    showForm: false,
    backgroundFooter: ''
  }),

  mounted() {
    store.dispatch('loading/finishLoading');
    this.onResize();
  },

  events: {
    [HANDLERS.SHOW_BACKGROUND]: 'changeBackground',
    [HANDLERS.ENABLE_FOOTER]: 'loaddingFooter'
  },

  async beforeCreate() {
    this.token = getToken();

    await store.dispatch('authentication/getApiUrl');

    const layout = store.getters['layout/getConfigLayout'];
    this.$vuetify.theme.dark = layout.dark;

    const theme = store.getters['layout/getConfigTheme'];

    for (let [key, value] of Object.entries(theme)) {
      if (value) {
        this.$vuetify.theme.themes.light[key] = value;
        this.$vuetify.theme.themes.dark[key] = value;
      }
    }
  },

  created() {
    store.dispatch('loading/startLoading');
  },

  computed: {
    configLayout() {
      const layout = store.getters['layout/getConfigLayout'];

      this.$vuetify.theme.dark = layout.dark;

      return layout;
    },

    configFooter: () => store.getters['layout/getConfigFooter'],

    getError500: () => store.getters['errors/getError500'].options,

    config: () => store.getters['authentication/getConfig']
  },

  methods: {
    onResize() {
      this.innerWidth = window.innerWidth;
    },

    changeBackground(item) {
      this.background = '';

      let widthPage = window.innerWidth;
      let style = 'background-size: cover; background-position: center center; background-attachment: fixed;';

      if (!item) return;

      let isBg = false;
      Object.values(item).forEach(item => {
        if (item) isBg = true;
      });

      if (!isBg) return;

      if (widthPage > 768) {
        if (item.desktopImage) this.background = `background-image: url(' ${item.desktopImage} '); ${style}`;

        if (item.desktopColor) this.background = `background-color: ${item.desktopColor}`;
      } else {
        if (item.mobileImage) this.background = `background-image: url(' ${item.mobileImage} '); ${style}`;

        if (item.mobileColor) this.background = `background-color: ${item.mobileColor}`;
      }

      if (this.configFooter.spacingBetweenContent) {
        this.background = `${this.background}; padding-bottom: ${this.configFooter.spacingBetweenContent}`;
      }
    },

    changeBackgroundFooter() {
      this.backgroundFooter = '';
      let style = 'background-size: cover; background-position: center center; background-attachment: fixed;';

      if (this.configFooter.background.image) {
        this.backgroundFooter = `background-image: url(' ${this.configFooter.background.image} '); ${style}`;
      }

      if (this.configFooter.background.color) {
        this.backgroundFooter = `background-color: ${this.configFooter.background.color} ;`;
      }
    },

    async loaddingFooter() {
      if (this.configFooter.visible) {
        await store.dispatch('page/load', { page: this.configFooter.page, mode: this.configFooter.mode });
        this.showForm = true;

        this.changeBackgroundFooter();
      }
    }
  },

  watch: {
    $route() {
      this.token = getToken();
    }
  }
};
</script>
